import { useTranslation } from 'react-i18next';
import { PersonalizationTableRowValues } from './PersonalizationDetails';
import { useGetPersonalizationItemsSubtotalAmount } from './PersonalizationItemList';
import { PersonalizationSummaryTotalInfo } from './PersonalizationSummaryTotalInfo';

interface Props {
  allPersonalizations: PersonalizationTableRowValues[];
  showBaseCost: boolean;
  showResidentPrice: boolean;
  preTax?: boolean;
}

export function PersonalizationSummaryHomeTotalBalance(props: Props) {
  const { showBaseCost, showResidentPrice, allPersonalizations, preTax } =
    props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'personalization.summary',
  });

  const { amount: personalizationsResidentPriceAmount } =
    useGetPersonalizationItemsSubtotalAmount(
      allPersonalizations,
      (x) =>
        preTax
          ? x.personalizationItem?.pricing?.residentPriceWithoutTax ??
            x.specialRequest?.prices?.residentPriceWithoutTax
          : x.totalResidentPrice,
      showResidentPrice,
    );
  const { amount: personalizationsBaseCostAmount } =
    useGetPersonalizationItemsSubtotalAmount(
      allPersonalizations,
      (x) => x.totalBaseCost,
      showBaseCost,
    );

  return (
    <PersonalizationSummaryTotalInfo
      title={t(preTax ? 'preTaxHomeTotal' : 'homeTotalTitle')}
      baseCostTotal={personalizationsBaseCostAmount}
      residentPriceTotal={personalizationsResidentPriceAmount}
      preTax={preTax}
      className={preTax ? 'mb-1' : undefined}
    />
  );
}
